module.exports = __webpack_public_path__ + "static/media/M.028371dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/M.jpg
// module id = 81
// module chunks = 0